import { render, staticRenderFns } from "./AppPrivacyPolicy.vue?vue&type=template&id=2e8fc8d2&scoped=true"
import script from "./AppPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./AppPrivacyPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fc8d2",
  null
  
)

export default component.exports